import React from 'react';
import { FlyerTemplate } from '../../../../../services/exports/Constants';
import FlyerOneForm from './FlyerOneForm';
import FlyerTwoForm from './FlyerTwoForm';
import FlyerThreeForm from './FlyerThreeForm';
import FlyerFourForm from './FlyerFourForm';

export default function FlyerForm({ template, ...rest }) {
  const FormComponent =
    {
      [FlyerTemplate.One]: FlyerOneForm,
      [FlyerTemplate.Two]: FlyerTwoForm,
      [FlyerTemplate.Three]: FlyerThreeForm,
      [FlyerTemplate.Four]: FlyerFourForm,
    }[template] ?? null;

  return <FormComponent {...rest} />;
}
